<div>
  <div class="message">{{data.message}}</div>
  <div fxLayoutAlign="row" fxLayoutGap="10px">
    <span class="fill-remaining-space"></span>
    <button mat-raised-button
            *ngFor="let option of data.options; let i = index"
            [id]="'button' + i"
            [color]="option.color"
            (click)="submit(option.returnValue)">
      {{option.label}}
    </button>
  </div>
</div>
